import { defineStore } from "pinia";
import { ref } from "vue";
import { SnackbarQueueMessage } from "vuetify";

export const useMessagesStore = defineStore("messages", () => {
  const queue = ref<SnackbarQueueMessage[]>([]);
  function add(message: SnackbarQueueMessage) {
    queue.value.push(message);
  }

  function error(message: SnackbarQueueMessage) {
    if(typeof message === "string") {
      add({ text: message, color: "disconnect" });
    }
    else {
      add({ ...message, color: "disconnect" });
    }
  }

  return { queue, add, error };
});
